import * as styledComponents from 'styled-components/native'

const { default: styled, css, ThemeProvider } = styledComponents

export { css, ThemeProvider }
export default styled
